import {
  FETCH_PRACTICELIST_REQUEST,
  FETCH_PRACTICELIST_SUCCESS,
  FETCH_PRACTICELIST_FAILURE,
} from "./practicecompListTypes";
import api from "../../utils/Api";

export const fetchPracticeListRequest = () => {
  return {
    type: FETCH_PRACTICELIST_REQUEST,
  };
};

export const fetchPracticeListSuccess = (practiceList) => {
  return {
    type: FETCH_PRACTICELIST_SUCCESS,
    payload: practiceList,
  };
};

export const fetchPracticeListFailure = (error) => {
  return {
    type: FETCH_PRACTICELIST_FAILURE,
    payload: error,
  };
};

export const fetchPracticeList = (searchKey, sortBy, page) => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchPracticeListRequest());
    try {
      const response = await api.get("practise/complaince/fetch", {
        headers: headers,
      });
      const practiceList = response.data.data;
     // console.log("************ Pracice list id ***************", practiceList);
      dispatch(fetchPracticeListSuccess(practiceList));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchPracticeListFailure(errorMsg));
    }
  };
};
